import { DepthProfile } from '@/models/ui/DepthProfile';


export interface  ILayermapState {
    status:string,    
    depthProfile:DepthProfile,
    depthProfileLoading:boolean,
    depthProfileProvider:string
  }
  

const state:ILayermapState = { 
    status: '',      
    depthProfile:new DepthProfile(),
    depthProfileLoading:false,
    depthProfileProvider: ''
  }
  
export default state